module.exports = __webpack_public_path__ + "img/estalagem03.a1ff1fa9.jpg";